import React, { Component, Fragment } from 'react';
import { Switch, Button, Tooltip } from 'antd';
import Translate from 'react-translate-component';
import { asyncConnect } from 'react-async-client';
import { path } from 'ramda';

import {
    putNotificationOptions,
    getNotificationOptions,
    postSubscribeNotification,
    postUnsubscribeNotification,
    getUser,
    getMenuCounters,
} from 'actions/asyncActions';
import { allowNotificationPermission } from 'actions/appActions';
import { isNotificationsSupported, getPermission } from 'utils/firebase';

const notificationOptions = [
    'notifyProjectsEnabled',
    'notifyPersonEnabled',
    'notifyNotDoneEnabled',
    'notifyEventEnabled',
    'notifyChangeRequestStatusEnabled',
];

const stateToProps = (state) => ({
    notification: state.notification,
    username: getUser.selectData(state).login,
    modals: state.modals,
    menuCounters: getMenuCounters.selectData(state),
});

@asyncConnect({
    getMenuCounters,
    putNotificationOptions,
    allowNotificationPermission,
    postSubscribeNotification,
    postUnsubscribeNotification,
    getNotificationOptions: getNotificationOptions
        .withOptions({ dispatchOnMount: true, resetOnUnmount: true }),
}, stateToProps)
class NotificaionView extends Component {
    onChangeSubscriptionOptions = (value, subscriptionType) => {
        const { putNotificationOptions, notification: { subscriptions } } = this.props;

        putNotificationOptions.dispatch({
            ...subscriptions,
            [subscriptionType]: value,
        });
    }

    onChangeSubscription = (value) => {
        const { username } = this.props;

        if (value) {
            this.props.postSubscribeNotification.dispatch({
                username,
            });
        } else {
            this.props.postUnsubscribeNotification.dispatch({
                username,
            });
        }
    }

    allowPermission = () => {
        this.props.allowNotificationPermission.dispatch();
    }

    getTooltipTitle = (item) => {
        const { menuCounters } = this.props;
        const notDoneCount = path(['notdone', 'count'], menuCounters)

        switch(item) {
            case 'notifyNotDoneEnabled':
                return notDoneCount ? <Translate content={'notify.toolTip.notDone'} with={{ notDoneCount }} /> : null;
            case 'notifyEventEnabled':
                return <Translate content={'notify.toolTip.events'} />;
            default:
                return null;
        }
    }

    renderSubscription = (notificationOptions) => {
        const { notificationPermission, subscriptions } = this.props.notification;

        return (
            notificationOptions.map((item, index) => {
                return (
                    <div className="notification-settings-row" key={index}>
                        <label>
                            <Tooltip placement='left' title={this.getTooltipTitle(item)}>
                                <Translate component="span" content={`options.${item}`} />
                            </Tooltip>
                        </label>
                        <Switch
                            disabled={!notificationPermission}
                            checked={subscriptions[item]}
                            onChange={value => this.onChangeSubscriptionOptions(value, item)}
                        />
                    </div>
                );
            })
        );
    }

    render() {
        const { notificationDisabled, notificationPermissionRequest, notificationPermission, notificationSubscribed, subscriptions } = this.props.notification;

        if (notificationDisabled) {
            return null;
        }

        return (
            <Fragment>
                <div className='setting-item'>
                    <div className='title'>
                        <Translate content='settings.notification' />
                    </div>
                    <div className='body notification-settings'>
                        { !isNotificationsSupported ? (
                            <div className='notification-settings-row permission'>
                                <label>
                                    <Translate  content={`notificationUnsupported`} />
                                </label>
                            </div>
                        ) : !notificationPermission ? (
                            <div className='notification-settings-row permission'>
                                <label>
                                    <Translate  content={`notificationPermission`} />
                                </label>
                                <Button
                                    size='small'
                                    onClick={this.allowPermission}
                                    className='notification-permission-button'
                                    disabled={notificationPermissionRequest}
                                >
                                    <Translate content='subscriptionEnable' />
                                </Button>
                            </div>
                        ) : (
                            <div className='notification-settings-row'>
                                <label>
                                    <Translate content='subscriptionStatus' />
                                </label>
                                <Switch
                                    disabled={!notificationPermission}
                                    checked={notificationSubscribed}
                                    onChange={value => getPermission().then(() => this.onChangeSubscription(value))}
                                />
                            </div>
                        )}
                    </div>
                </div>

                { notificationSubscribed && subscriptions && (
                    <div className='setting-item'>
                        <div className='title'>
                            <Translate component='span' content='subscriptions' />
                        </div>
                        <div className='body notification-settings'>
                            { this.renderSubscription(notificationOptions)}
                        </div>
                    </div>
                )}
            </Fragment>
        );
    }
}

export default NotificaionView;

